const ARTICLES = ['a', 'an', 'the'];
// prettier-ignore
const PREPOSITIONS = [
  'and', 'but', 'or',
  'to', 'from', 'between', 'on', 'at', 'in', 'out', 'into', 'for', 'of', 'as',
  'off', 'by', 'with', 'without', 'against', 'before', 'after', 'about', 'around',
];

const toTitle = (text: string): string => {
  return text
    .split(/[-_ ]/)
    .map((word: string, index: number): string => {
      if (index === 0) {
        return word.slice(0, 1).toUpperCase() + word.slice(1);
      }
      if (ARTICLES.includes(word) || PREPOSITIONS.includes(word)) {
        return word;
      }
      return word.slice(0, 1).toUpperCase() + word.slice(1);
    })
    .join(' ');
};

const toCamel = (text: string): string => {
  return text
    .split(/[-_ ]/)
    .map((word: string, index: number): string => {
      if (index === 0) {
        return word.slice(0, 1).toLowerCase() + word.slice(1);
      }
      return word.slice(0, 1).toUpperCase() + word.slice(1);
    })
    .join('');
};

const toPascal = (text: string): string => {
  return text
    .split(/[-_ ]/)
    .map((word: string): string => {
      return word.slice(0, 1).toUpperCase() + word.slice(1);
    })
    .join('');
};

const toSnake = (text: string): string => {
  return text
    .replace(/[- ]/g, '_')
    .split(/(?=[A-Z])/)
    .map((word: string): string => {
      return word.toLowerCase();
    })
    .join('_')
    .replace(/__+/g, '_');
};

const normalizeJapanese = (text: string): string => {
  return (
    text
      // 文字列の前後の空白を削除する
      .trim()
      // 文字を正規化(半角カタカナを全角に変換、全角英数字とスペースを半角に変換、特殊文字を変換など)する
      .normalize('NFKC')
      // 大文字のアルファベットを小文字に統一する
      .toLocaleLowerCase('en')
      // カタカナをひらがなに統一する
      .replace(/[\u30a1-\u30f6]/g, (char: string): string => {
        return String.fromCharCode(char.charCodeAt(0) - 0x60);
      })
  );
};

export { toTitle, toCamel, toPascal, toSnake, normalizeJapanese };
